/**
 * Auth utilities for token management
 * Supports both localStorage (stay logged in) and sessionStorage (session-only)
 */

/**
 * Get the auth token from storage
 * Checks localStorage first (stay logged in), then sessionStorage
 */
export const getAuthToken = () => {
  return localStorage.getItem('token') || sessionStorage.getItem('token');
};

/**
 * Clear all auth tokens and related data
 */
export const clearAuthTokens = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('stayLoggedIn');
  sessionStorage.removeItem('token');
};

/**
 * Check if user is logged in
 */
export const isLoggedIn = () => {
  return !!getAuthToken();
};

/**
 * Store auth token based on remember preference
 * @param {string} token - The JWT token
 * @param {boolean} remember - Whether to persist across sessions
 */
export const storeAuthToken = (token, remember = false) => {
  clearAuthTokens();
  if (remember) {
    localStorage.setItem('token', token);
    localStorage.setItem('stayLoggedIn', 'true');
  } else {
    sessionStorage.setItem('token', token);
  }
};
